import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from 'src/apis/HttpBaseApiWrapper';
import { useScoreService } from 'src/apis/score/useScoreService';
import { IScoreListQueryParams, IScoreListApiResponse } from 'src/apis/score/score.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getScoreListKey = 'get-score-list';

export const useScoreListHook = (
  params: IScoreListQueryParams,
  options?: UseQueryOptions<IScoreListApiResponse, TQueryError>
): UseQueryResult<IScoreListApiResponse, TQueryError> => {
  const { listScoreRecords } = useScoreService();

  return useQuery<IScoreListApiResponse, TQueryError>({
    queryKey: [getScoreListKey, params],
    queryFn: () => listScoreRecords(params),
    enabled: true,
    ...options,
  });
};
